export default __webpack_public_path__ + "static/media/rocket.771194d5.svg";